<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid px-0">
    <div class="row">
      <div class="col-5 m-0 px-0">
        <div class="date-selector-font" style="display:inline-table;margin-right:-25px;">
          <a href="#" class="btn btn-link p-0 mb-1" style="color:initial;" @click="stepPrevious()"><i class="icon-arrow-left22"></i></a>
          {{datelabel}}
          <a href="#" class="btn btn-link p-0 mb-1" style="color:initial;" @click="stepNext()"><i class="icon-arrow-right22"></a>
        </div>
      </div>
      <div class="col-7 m-0 text-right px-0">
        <button type="button" class="btn btn-link btn-light" data-toggle="dropdown">
          {{$t(selectedMode)}} <i class="icon-checkmark2"></i>
        </button>
        <div class="dropdown-menu">
          <a class="dropdown-item" data-boundary="viewport" @click="selectMode('day')">{{$t('day')}}</a>
          <a class="dropdown-item" data-boundary="viewport" @click="selectMode('week')">{{$t('week')}}</a>
          <a class="dropdown-item" data-boundary="viewport" @click="selectMode('month')">{{$t('month')}}</a>
          <a class="dropdown-item" data-boundary="viewport" @click="selectMode('year')">{{$t('year')}}</a>
        </div>
      </div>
    </div>   
  </div>
</template>

<script>

  import moment from 'moment'

  export default {
    name: 'viewmaker-date-selector',
    components: {
    },
    data() {
      return {
        datelabel: 'date',
        startDate: null,
        endDate: null,
        selectedMode: 'day',
        mom: null,
      }
    },
    props: {
      multiplerowclick: {
        required: false,
        type: String,
        default: ''
      },
    },
    methods: {
      setDate(startDate) {
        this.startDate = startDate;
        this.endDate = this.startDate;
        this.renderLabel();
      },
      selectMode(mode) {
        this.selectedMode = mode;
        if (this.selectedMode == 'day') {
          this.endDate = this.startDate;
          //this.endDate = this.$store.getMomentLocale(this.startDate).add(1, 'days')
          //this.endDate = this.startDate.add(1, 'days');
        }
        else if (this.selectedMode == 'week') {
          this.startDate = this.startDate.startOf('week');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('week');
          //this.endDate = this.endDate.endOf('week');
        }
        else if (this.selectedMode == 'month') {
          this.startDate = this.startDate.startOf('month');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('month');
          //this.endDate = this.endDate.endOf('month');
        }
        else if (this.selectedMode == 'year') {
          this.startDate = this.startDate.startOf('year');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('year');
          //this.endDate = this.endDate.endOf('month');
        }
        
        this.renderLabel();
        this.$emit("changed", this.startDate, this.endDate)
      },
      stepPrevious() {
        if (this.selectedMode == 'day') {
          this.startDate = this.startDate.subtract(1, 'days');
          this.endDate = this.startDate;
          //this.endDate = this.$store.getMomentLocale(this.startDate).add(1, 'days');
        }
        else if (this.selectedMode == 'week') {
          this.startDate = this.startDate.subtract(1, 'weeks').startOf('week');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('week');
          //this.endDate = this.endDate.subtract(1, 'weeks').endOf('week');
        }
        else if (this.selectedMode == 'month') {
          this.startDate = this.startDate.subtract(1, 'months').startOf('month');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('month');
          //this.endDate = this.endDate.subtract(1, 'months').endOf('month');
        }
        else if (this.selectedMode == 'year') {
          this.startDate = this.startDate.subtract(1, 'year').startOf('year');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('year');
          //this.endDate = this.endDate.subtract(1, 'months').endOf('month');
        }
        this.renderLabel();
        this.$emit("changed", this.startDate, this.endDate)
      },
      stepNext() {
        if (this.selectedMode == 'day') {
          this.startDate = this.startDate.add(1, 'days');
          this.endDate = this.startDate;
          //this.endDate = this.$store.getMomentLocale(this.endDate).add(1, 'days');
        }
        else if (this.selectedMode == 'week') {
          this.startDate = this.startDate.add(1, 'weeks').startOf('week');
          this.endDate = this.$store.getMomentLocale(this.endDate).endOf('week');
        }
        else if (this.selectedMode == 'month') {
          this.startDate = this.startDate.add(1, 'months').startOf('month');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('month');
        }
        else if (this.selectedMode == 'year') {
          this.startDate = this.startDate.add(1, 'year').startOf('year');
          this.endDate = this.$store.getMomentLocale(this.startDate).endOf('year');
        }
        this.renderLabel();
        this.$emit("changed", this.startDate, this.endDate)
      },
      renderLabel() {
        if (this.selectedMode == 'day') {
          this.datelabel = this.startDate.format('LL');
        }
        else if (this.selectedMode == 'week') {
          this.datelabel = this.startDate.format('LL') + " - " + this.endDate.format('LL');
        }
        else if (this.selectedMode == 'month') {
          this.datelabel = this.startDate.format('LL') + " - " + this.endDate.format('LL');
        }
        else if (this.selectedMode == 'year') {
          this.datelabel = this.startDate.format('LL') + " - " + this.endDate.format('LL');
        }
      },
      getDate() {
        return {
          startDate: this.startDate,
          endDate: this.endDate
        }
      },
    },
    
    created() {
      this.startDate = this.$store.getMomentLocale(new Date()).startOf('day');
      this.endDate = this.startDate;
      //this.endDate = this.$store.getMomentLocale(new Date()).add(1, 'days').startOf('day');
    },
    mounted() {      
      this.renderLabel();
    },

    watch: {
      something: function (newVal, oldVal) {
        
      },
    }
  }
</script>

<style scoped>

  .date-selector-font{
      font-size:20px;
  }
  .custom-text-align {
    text-align: right !important;
  }

  @media (max-width: 767px) {
    .date-selector-font {
      font-size: 11px;
    }
    .custom-text-align {
      text-align: left !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/viewmaker/viewmaker-date-selector.vue